import * as types from './column.types';
import * as constants from './column.constants';
import { generateClearResourceAction, generateStoreResourceAction } from '../generators/resource.actions';

export const storeColumn = generateStoreResourceAction<types.IColumn>(constants.STORE_COLUMN);
export const clearColumn = generateClearResourceAction(constants.CLEAR_COLUMN);
